import getAPI from './getAPI.js'

export default async function getOnboardingInvites() {
    const data = await getAPI('admin/onboarding/invites');
    return data;
}
